import { signal } from "@preact/signals";

import readlangClient from "readlangClient";

export type ImpersonationInfo = {
  targetEmail: string;
  /** Epoch milliseconds at which the server stops honouring the session. */
  expiresAt: number;
};

/**
 * Set from the `impersonation` field of `GET /api/user`, so it tracks the
 * server-side session rather than anything the client decides.
 */
export const info = signal<ImpersonationInfo | undefined>(undefined);

export const exit = async () => {
  try {
    await readlangClient.request("POST", "/api/admin/impersonate/stop", {});
  } finally {
    // Full reload rather than a store refresh: every store in memory holds the
    // impersonated user's data, and the browser is now signed out (see
    // src/impersonation.js) so the admin logs in again from here. The reload
    // happens even if the request failed, since an already-expired session has
    // signed itself out too.
    window.location.href = "/";
  }
};
